import React from 'react';

import { allCountriesWithCustomLabel } from '../../utils/countryCodes';

import { SelectCountryContainer } from './styles';

export default function SelectCountry({ label, selected, onSelect, fullWidth, ...props }) {
  return (
    <SelectCountryContainer
      fullWidth={fullWidth}
      placeholder={label}
      selected={selected}
      onSelect={onSelect}
      customLabels={allCountriesWithCustomLabel}
      {...props}
    />
  );
}
